/**
 * Handle header click - toggle item open/closed state
 */
export function hdl_header_click(event) {
  const header = event.currentTarget;
  const item = header.closest('[g-ref="items"]') || header.parentElement;

  if (!item) return;

  const isOpen = item.getAttribute("data-open") === "true";
  item.setAttribute("data-open", isOpen ? "false" : "true");
}
